import {airlineAdminApi} from './api/airlineAdminApi';
import {ciApi} from './api/ciApi';
import {ciiApi} from './api/ciiApi';
import {flightApi} from './api/flightApi';
import {otpApi} from './api/otpApi';
import airportSlice from './slice/airportSlice';
import chatSlice from './slice/chatSlice';
import flightSlice from './slice/flightSlice';
import mapSlice from './slice/mapSlice';
import otpSlice from './slice/otpSlice';
import toastSlice from './slice/toastSlice';
import userSlice from './slice/userSlice';
import appSlice from '@/redux/slice/appSlice';
import ciSlice from '@/redux/slice/ciSlice';
import emissionSlice from '@/redux/slice/emissionSlice';
import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

const middleware: any = [
  flightApi.middleware,
  ciApi.middleware,
  otpApi.middleware,
  ciiApi.middleware,
  airlineAdminApi.middleware
];
// Development middleware
if (import.meta.env.DEV) {
  // middleware.push(logger);
}

// Create the global store
const store = configureStore({
  reducer: {
    app: appSlice,
    user: userSlice,
    flight: flightSlice,
    toast: toastSlice,
    airport: airportSlice,
    chat: chatSlice,
    map: mapSlice,
    ci: ciSlice,
    otp: otpSlice,
    emission: emissionSlice,
    [flightApi.reducerPath]: flightApi.reducer,
    [ciApi.reducerPath]: ciApi.reducer,
    [otpApi.reducerPath]: otpApi.reducer,
    [ciiApi.reducerPath]: ciiApi.reducer,
    [airlineAdminApi.reducerPath]: airlineAdminApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
setupListeners(store.dispatch);
export default store;
